import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  deviceImage: {
    marginLeft: 24,
    width: 48,
    height: 96,
  },
  firstTitle: {
    marginLeft: 38,
    marginBottom: 8,
    marginTop: 16,
  },
  title: {
    marginLeft: 38,
    marginBottom: 8,
    marginTop: 37,
  },
  subtitle: {
    marginLeft: 38,
  },
  button: {
    width: '100%',
    height: 27,
    marginTop: 56,
    marginBottom: 6,
  },
});
